// removed by extract-text-webpack-plugin
module.exports = {"disclaimerId":"_1nMX313k63"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/secure/Dashboard/AccountList/AccountCard/DisclaimerId/DisclaimerId.module.less
// module id = 976
// module chunks = 3